import * as React from 'react';

function Edit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={15}
      data-testid="edit-icon"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.898 1.297a1.766 1.766 0 012.489 0l1.066 1.066a1.766 1.766 0 010 2.489l-1.312 1.312L9.586 2.61l1.312-1.312zm1.614 5.496L6.14 13.164a2.383 2.383 0 01-1.012.602l-3.309.957a.558.558 0 01-.629-.164.62.62 0 01-.191-.63l.984-3.308c.11-.383.329-.738.602-1.012l6.371-6.37 3.555 3.554z"
        fill="#828282"
      />
    </svg>
  );
}

export default Edit;
